var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("notifications", {
        staticClass: "block-user-employee",
        attrs: { group: "block-user-employee", position: "bottom right" },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function ({ item }) {
              return [
                _c("div", { staticClass: "block-user-employee-content" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "14",
                        height: "10",
                        viewBox: "0 0 14 10",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M4.47288 9.68401C4.08236 9.29348 4.08236 8.66032 4.47288 8.2698L12.2929 0.449632C12.6835 0.0591074 13.3166 0.059107 13.7072 0.449631C14.0977 0.840156 14.0977 1.47332 13.7072 1.86384L5.8871 9.68401C5.49657 10.0745 4.86341 10.0745 4.47288 9.68401Z",
                          fill: "#12C971",
                        },
                      }),
                      _c("path", {
                        attrs: {
                          d: "M5.8871 9.68401C6.27762 9.29348 6.27756 8.66032 5.88704 8.2698L1.70711 4.08989C1.31658 3.69937 0.683417 3.69937 0.292893 4.08989C-0.097631 4.48042 -0.0976311 5.11358 0.292893 5.50411L4.47288 9.68401C4.86341 10.0745 5.49657 10.0745 5.8871 9.68401Z",
                          fill: "#12C971",
                        },
                      }),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "block-user-employee-content-description" },
                    [
                      _vm._v(" Пользователь "),
                      _c(
                        "span",
                        {
                          staticClass:
                            "block-user-employee-content-description-bold",
                        },
                        [_vm._v(_vm._s(item.data.userName))]
                      ),
                      _vm._v(" для сотрудника "),
                      _c(
                        "span",
                        {
                          staticClass:
                            "block-user-employee-content-description-bold",
                        },
                        [_vm._v(_vm._s(item.data.employeeName))]
                      ),
                      _vm._v(" " + _vm._s(item.data.blockType) + " "),
                    ]
                  ),
                ]),
              ]
            },
          },
        ]),
      }),
      _c("notifications", {
        staticClass: "block-user-employee",
        attrs: { group: "change-status-employee", position: "bottom right" },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function ({ item }) {
              return [
                _c("div", { staticClass: "block-user-employee-content" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "14",
                        height: "10",
                        viewBox: "0 0 14 10",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M4.47288 9.68401C4.08236 9.29348 4.08236 8.66032 4.47288 8.2698L12.2929 0.449632C12.6835 0.0591074 13.3166 0.059107 13.7072 0.449631C14.0977 0.840156 14.0977 1.47332 13.7072 1.86384L5.8871 9.68401C5.49657 10.0745 4.86341 10.0745 4.47288 9.68401Z",
                          fill: "#12C971",
                        },
                      }),
                      _c("path", {
                        attrs: {
                          d: "M5.8871 9.68401C6.27762 9.29348 6.27756 8.66032 5.88704 8.2698L1.70711 4.08989C1.31658 3.69937 0.683417 3.69937 0.292893 4.08989C-0.097631 4.48042 -0.0976311 5.11358 0.292893 5.50411L4.47288 9.68401C4.86341 10.0745 5.49657 10.0745 5.8871 9.68401Z",
                          fill: "#12C971",
                        },
                      }),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "block-user-employee-content-description" },
                    [
                      _vm._v(" Статус сотрудника "),
                      _c(
                        "span",
                        {
                          staticClass:
                            "block-user-employee-content-description-bold",
                        },
                        [_vm._v(_vm._s(item.data.employeeName))]
                      ),
                      _vm._v(" успешно изменён "),
                    ]
                  ),
                ]),
              ]
            },
          },
        ]),
      }),
      _c("notifications", {
        staticClass: "block-user-employee",
        attrs: { group: "success-message", position: "bottom right" },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function ({ item }) {
              return [
                _c("div", { staticClass: "block-user-employee-content" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "14",
                        height: "10",
                        viewBox: "0 0 14 10",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M4.47288 9.68401C4.08236 9.29348 4.08236 8.66032 4.47288 8.2698L12.2929 0.449632C12.6835 0.0591074 13.3166 0.059107 13.7072 0.449631C14.0977 0.840156 14.0977 1.47332 13.7072 1.86384L5.8871 9.68401C5.49657 10.0745 4.86341 10.0745 4.47288 9.68401Z",
                          fill: "#12C971",
                        },
                      }),
                      _c("path", {
                        attrs: {
                          d: "M5.8871 9.68401C6.27762 9.29348 6.27756 8.66032 5.88704 8.2698L1.70711 4.08989C1.31658 3.69937 0.683417 3.69937 0.292893 4.08989C-0.097631 4.48042 -0.0976311 5.11358 0.292893 5.50411L4.47288 9.68401C4.86341 10.0745 5.49657 10.0745 5.8871 9.68401Z",
                          fill: "#12C971",
                        },
                      }),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "success-message-content-description",
                      domProps: { innerHTML: _vm._s(item.data.textMessage) },
                    },
                    [_vm._v(" " + _vm._s(item.data.textMessage) + " ")]
                  ),
                ]),
              ]
            },
          },
        ]),
      }),
      _c("notifications", {
        staticClass: "calculation-success",
        attrs: {
          group: "calculation-success-message",
          position: "bottom right",
        },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function ({ item }) {
              return [
                _c("div", { staticClass: "calculation-success-content" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "14",
                        height: "10",
                        viewBox: "0 0 14 10",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M4.47288 9.68401C4.08236 9.29348 4.08236 8.66032 4.47288 8.2698L12.2929 0.449632C12.6835 0.0591074 13.3166 0.059107 13.7072 0.449631C14.0977 0.840156 14.0977 1.47332 13.7072 1.86384L5.8871 9.68401C5.49657 10.0745 4.86341 10.0745 4.47288 9.68401Z",
                          fill: "#12C971",
                        },
                      }),
                      _c("path", {
                        attrs: {
                          d: "M5.8871 9.68401C6.27762 9.29348 6.27756 8.66032 5.88704 8.2698L1.70711 4.08989C1.31658 3.69937 0.683417 3.69937 0.292893 4.08989C-0.097631 4.48042 -0.0976311 5.11358 0.292893 5.50411L4.47288 9.68401C4.86341 10.0745 5.49657 10.0745 5.8871 9.68401Z",
                          fill: "#12C971",
                        },
                      }),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "success-message-content-description",
                      domProps: { innerHTML: _vm._s(item.data.textMessage) },
                    },
                    [_vm._v(" " + _vm._s(item.data.textMessage) + " ")]
                  ),
                ]),
              ]
            },
          },
        ]),
      }),
      _c("notifications", {
        staticClass: "error-message",
        attrs: { group: "error-message", position: "bottom right" },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function ({ item }) {
              return [
                _c("div", { staticClass: "error-message-content" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "14",
                        height: "14",
                        viewBox: "0 0 14 14",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("circle", {
                        attrs: {
                          cx: "7",
                          cy: "7",
                          r: "6.5",
                          stroke: "#FF238D",
                        },
                      }),
                      _c("circle", {
                        attrs: { cx: "7", cy: "10", r: "1", fill: "#FF238D" },
                      }),
                      _c("rect", {
                        attrs: {
                          x: "6",
                          y: "3",
                          width: "2",
                          height: "5",
                          rx: "1",
                          fill: "#FF238D",
                        },
                      }),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "error-message-content-description",
                      domProps: { innerHTML: _vm._s(item.data.textMessage) },
                    },
                    [_vm._v(" " + _vm._s(item.data.textMessage) + " ")]
                  ),
                ]),
              ]
            },
          },
        ]),
      }),
      _c("notifications", {
        staticClass: "error-message center-error-message",
        attrs: { group: "center-error-message", position: "center center" },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function ({ item }) {
              return [
                _c("div", { staticClass: "error-message-content" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "14",
                        height: "14",
                        viewBox: "0 0 14 14",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("circle", {
                        attrs: {
                          cx: "7",
                          cy: "7",
                          r: "6.5",
                          stroke: "#FF238D",
                        },
                      }),
                      _c("circle", {
                        attrs: { cx: "7", cy: "10", r: "1", fill: "#FF238D" },
                      }),
                      _c("rect", {
                        attrs: {
                          x: "6",
                          y: "3",
                          width: "2",
                          height: "5",
                          rx: "1",
                          fill: "#FF238D",
                        },
                      }),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "error-message-content-description",
                      domProps: { innerHTML: _vm._s(item.data.textMessage) },
                    },
                    [_vm._v(" " + _vm._s(item.data.textMessage) + " ")]
                  ),
                ]),
              ]
            },
          },
        ]),
      }),
      _c("notifications", {
        staticClass: "file-error-message",
        attrs: { group: "file-error-message", position: "center" },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function ({ item }) {
              return [
                _c("div", { staticClass: "error-message-content" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "14",
                        height: "14",
                        viewBox: "0 0 14 14",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("circle", {
                        attrs: {
                          cx: "7",
                          cy: "7",
                          r: "6.5",
                          stroke: "#FF238D",
                        },
                      }),
                      _c("circle", {
                        attrs: { cx: "7", cy: "10", r: "1", fill: "#FF238D" },
                      }),
                      _c("rect", {
                        attrs: {
                          x: "6",
                          y: "3",
                          width: "2",
                          height: "5",
                          rx: "1",
                          fill: "#FF238D",
                        },
                      }),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "error-message-content-description",
                      domProps: { innerHTML: _vm._s(item.data.textMessage) },
                    },
                    [_vm._v(" " + _vm._s(item.data.textMessage) + " ")]
                  ),
                ]),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }